// @flow

import React from 'react'
import styled from 'styled-components'
import ImageGallery from 'react-image-gallery'
import Colors from 'components/styles/colors'
import ReputationStar from 'components/shared/ReputationStar'
import CardPriceIconWrapper from 'components/shared/CardPriceIconWrapper'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imagePath } from 'frontend_core/dist/helpers/image'

const ThumbnaiPagerlIcon = styled.i`
  position: absolute;
  top: 50%;
  width: 100%;
  margin-top: -0.5em;
  font-size: 30px;
  color: rgb(255, 255, 255);
  text-shadow: rgba(0, 0, 0, 0.4) 0 0 2px;
  text-align: center;
  opacity: 0.8;
`
const ThumbnailWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;

  &::before {
    content: '';
    display: block;
    padding-top: 66.666%;
  }
`
const ThumbnailInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: ${Colors.grayE};
`
const ThumbnailPager = styled.span`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50px;

  &:hover {
    ${ThumbnaiPagerlIcon} {
      /* stylelint-disable-line */
      opacity: 0.6;
    }
  }

  &[data-pager-type='prev'] {
    right: auto;
    left: 0;
  }

  &[data-pager-type='next'] {
    right: 0;
    left: auto;
  }
`

const CardBody = styled.div`
  overflow: hidden;
`
const CardTitle = styled.h3`
  padding-top: 8px;
  color: ${Colors.black};
  font-size: 14px;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const CardPriceContainer = styled.div`
  display: table;
  table-layout: fixed;
  margin-top: 4px;
  line-height: 1;
`
const CardPrice = styled.span`
  display: table-cell;
  color: ${Colors.black};
  font-size: 16px;
  font-weight: bold;
`
const CardInfoText = styled.p`
  margin-top: 4px;
  color: ${Colors.black};
  font-size: 11px;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
const CardInfoList = styled.ul`
  margin-top: 4px;
`
const CardInfoListItem = styled.li`
  display: inline-block;

  &:not(:first-of-type) {
    margin-left: 8px;
  }
`
const CardTextIcon = styled.i`
  margin-right: 5px;
  color: ${Colors.grayD};
  font-size: 12px;
`
const CardIconText = styled.span`
  color: ${Colors.black};
  font-size: 11px;
  line-height: 1.5;
`
const ReviewCount = styled.span`
  color: ${Colors.black};
  font-size: 11px;
`
export const CardPriceSmall = styled.span`
  font-size: 14px;
  font-weight: normal;
`

const SponsoredPromotionList = styled.ul`
  margin-top: 8px;
`

const SponsoredPromotionListItem = styled.li`
  display: inline-block;
  font-size: 10px;
  margin-right: 4px;
`

const SponsoredPromotionLink = styled.a`
  display: inline-block;
  border: 1px solid ${Colors.blue};
  border-radius: 10px;
  padding: 3px 6px;
  &:hover {
    border-color: ${Colors.lightblue};
    color: ${Colors.lightblue};
  }
`

export type PropTypes = {
  id: number,
  uid: ?string,
  isPaddingCard: boolean,
  roomLink: string,
  thumbnails: Array<{
    imageUrl: string,
    imageAlt: string,
  }>,
  title: string,
  price: string,
  unit: string,
  isDirectReservation: boolean,
  isTopHost: boolean,
  isLastMinutesDiscount: boolean,
  capacity: string,
  location: string,
  reviewScore: number,
  reviewCount: string,
  reviewLink: string,
  access: string,
  isInquiryOnly: boolean,
  service: string,
  onClickFavorite: Function,
  isFavorite: boolean,
  sponsoredPromotions: Array<{
    id: number,
    brandName: string,
    link: string,
  }>,
}

export default class RoomCard extends React.Component<PropTypes> {
  props: PropTypes
  imageGallery: ImageGallery

  render() {
    if (this.props.isPaddingCard) {
      return (
        <div>
          <ThumbnailWrapper />
        </div>
      )
    }

    const cardPrice = this.props.isInquiryOnly ? (
      <CardPrice>{i18n.t('page.room.inquiry')}</CardPrice>
    ) : (
      <CardPrice>
        {this.props.price}
        <CardPriceSmall>{this.props.unit}</CardPriceSmall>
      </CardPrice>
    )

    const getFavoriteiconClassName = this.props.isFavorite
      ? 'units-item-fav__on'
      : 'units-item-fav'

    return (
      <div>
        <ThumbnailWrapper>
          <ThumbnailInner>
            <a
              href="#"
              aria-label="favorit"
              className={getFavoriteiconClassName}
              onClick={(e: Event) =>
                this.props.onClickFavorite(e, this.props, this.props.isFavorite)
              }
            >
              <i className="fa fa-heart" />
            </a>
            <a href={this.props.roomLink} target="_blank">
              <ImageGallery
                ref={ref => {
                  this.imageGallery = ref
                }}
                items={this.props.thumbnails}
                infinite
                lazyLoad
                showThumbnails={false}
                showPlayButton={false}
                showFullscreenButton={false}
                showNav={false}
                disableArrowKeys
                slideDuration={300}
                defaultImage={imagePath('noimage_search.png')}
                renderItem={item => (
                  <div className="image-gallery-image">
                    <OptimizedImage
                      src={item.imageUrl || ''}
                      alt={item.imageAlt}
                      type="flex"
                    />
                  </div>
                )}
              />
            </a>
            <ThumbnailPager
              aria-label="previous"
              data-pager-type="prev"
              onClick={(e: Event) => {
                e.preventDefault()
                this.imageGallery.slideToIndex(
                  this.imageGallery.getCurrentIndex() - 1,
                )
              }}
            >
              <ThumbnaiPagerlIcon className="fa fa-chevron-left" />
            </ThumbnailPager>
            <ThumbnailPager
              href="#"
              aria-label="next"
              data-pager-type="next"
              onClick={(e: Event) => {
                e.preventDefault()
                this.imageGallery.slideToIndex(
                  this.imageGallery.getCurrentIndex() + 1,
                )
              }}
            >
              <ThumbnaiPagerlIcon className="fa fa-chevron-right" />
            </ThumbnailPager>
          </ThumbnailInner>
        </ThumbnailWrapper>
        <a href={this.props.roomLink} target="_blank">
          <CardBody>
            <CardTitle>{this.props.title}</CardTitle>
            <CardPriceContainer>
              {cardPrice}
              <CardPriceIconWrapper
                isDirectReservation={this.props.isDirectReservation}
                isTopHost={this.props.isTopHost}
                isLastMinutesDiscount={this.props.isLastMinutesDiscount}
                service={this.props.service}
              />
            </CardPriceContainer>
            <CardInfoList>
              <CardInfoListItem>
                <CardTextIcon className="fa fa-user" />
                <CardIconText>{this.props.capacity}</CardIconText>
              </CardInfoListItem>
              <CardInfoListItem>
                <CardTextIcon className="fa fa-map-marker" />
                <CardIconText>{this.props.location}</CardIconText>
              </CardInfoListItem>
              <CardInfoListItem>
                <ReputationStar
                  score={this.props.reviewScore}
                  nolink
                  size={'small'}
                />
                <ReviewCount>
                  {i18n.t('page.room.numberOf', {
                    count: this.props.reviewCount,
                  })}
                </ReviewCount>
              </CardInfoListItem>
            </CardInfoList>
            <CardInfoText>{this.props.access}</CardInfoText>
            <SponsoredPromotionList>
              {(this.props.sponsoredPromotions || []).map(promo => (
                <SponsoredPromotionListItem
                  key={`sponsoredPromotions_${promo.id}`}
                >
                  <SponsoredPromotionLink href={promo.link} target="_blank">
                    {promo.brandName}
                  </SponsoredPromotionLink>
                </SponsoredPromotionListItem>
              ))}
            </SponsoredPromotionList>
          </CardBody>
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/RoomCard.jsx